let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9UYt3")).then(() => parcelRequire('92Llh'));